import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Chapter1, Chapter2, Chapter3, Chapter4, Chapter5 } from './chapters';

const chapters = [
  { title: 'Kurze Einführung', content: <Chapter1 />, id: 'chapter-1' },
  { title: 'Fuhrparks hinzufügen und löschen', content: <Chapter2 />, id: 'chapter-2' },
  { title: 'Fahrzeuge hinzufügen und löschen', content: <Chapter3 />, id: 'chapter-3' },
  { title: 'Reifen erstellen und montieren', content: <Chapter4 />, id: 'chapter-4' },
  { title: 'Reifen löschen', content: <Chapter5 />, id: 'chapter-5' },
];

const KnowledgeBase = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const filteredChapters = chapters.filter(chapter =>
    chapter.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <h1>Knowledge Base</h1>
      <TextField
        label="Suche"
        variant="outlined"
        fullWidth
        margin="normal"
        onChange={e => setSearchTerm(e.target.value)}
      />
      {filteredChapters.map(({ title, id, content }) => (
        <Accordion key={id} expanded={expanded === id} onChange={handleChange(id)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
          <AccordionDetails>{content}</AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default KnowledgeBase;
